import { Opportunity } from '../../../types/content';
import { LastActionData } from '../../services/authTypes';
import { AppDispatch } from '../configureStore';
import { ModalConfig } from '../reducers/globalModalReducer';
import {
  GLOBAL_MODAL_CLOSE_STATUS,
  GLOBAL_MODAL_CONFIGURATION,
  TOGGLE_APPLY_MODAL,
  TOGGLE_GLOBAL_MODAL
} from './types';

export const toggleModal = (status: boolean) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: TOGGLE_GLOBAL_MODAL,
    payload: status
  });
};

export const disableModalCloseBtn = (status: boolean) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: GLOBAL_MODAL_CLOSE_STATUS,
    payload: status
  });
};

export const setModalConfiguration = (configContent: ModalConfig) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: GLOBAL_MODAL_CONFIGURATION,
    payload: configContent
  });
};

export const toggleApply = (status: boolean, opportunity?: Opportunity) => async (dispatch: AppDispatch) => {
  return dispatch({
    type: TOGGLE_APPLY_MODAL,
    payload: { status: status, opportunity }
  });
};
